import { render, staticRenderFns } from "./OtpVerificationModal.vue?vue&type=template&id=20323370&scoped=true"
import script from "./OtpVerificationModal.vue?vue&type=script&lang=js"
export * from "./OtpVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./OtpVerificationModal.vue?vue&type=style&index=0&id=20323370&prod&lang=scss&scoped=true"
import style1 from "./OtpVerificationModal.vue?vue&type=style&index=1&id=20323370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20323370",
  null
  
)

export default component.exports